import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { STATES } from '../../../store/constants/clients';

import { create, update, get } from '../../../store/actions/facilities';
import FacilityDialogComponent from './FacilityDialog';

const BillingProviderNPITemplate = {
    billingProviderNPI: '',
    providerCCN: '',
}

export const FacilityDialog = connect(
    () => {
        const selectFacility = (state, props) => props.facility;
        const selectMode = (state, props) => {
            return props.facility ? 'edit' : 'create';
        }

        const mapBillingProviderNPIObject = (facility) => {
            if (facility && facility.billingProviderNpiDTO?.length > 0) {
                return facility.billingProviderNpiDTO.map(item => {
                    return {
                        ...item,
                        billingProviderNPI: item?.billingProviderNPI ?? '',
                        providerCCN: item?.providerCCN ?? '',
                    }
                })
            }
            return [BillingProviderNPITemplate]
        }

        function getFormattedState(state, states) {
            const foundState = states.find(item => item.displayName === state);
            return foundState ?? null
        }   

        function getInitialFormattedState(state, states) {
            const foundState = states.find(item => item.abbreviation === state);
            return foundState ?? null
        }   

        const selectInitialValues = createSelector(
            selectMode,
            selectFacility,
            (mode, facility) => {
                if (mode === 'edit' && facility) {
                    const payload = {
                        id: facility.id,
                        name: facility.name,
                        description: facility.description,
                        ein: facility.ein,
                        tin: facility.tin,
                        active: facility.active,
                        address: facility.address,
                        phone: facility.phone || '',
                        enableForPricer: facility.enableForPricer ?? false,
                        facilityNPI: facility.facilityNPI,
                        billingProviderNpiRequest: mapBillingProviderNPIObject(facility),
                        streetAddress: facility?.streetAddress || '',
                        state: getFormattedState(facility?.state, STATES) || '',
                        city: facility?.city || '',
                        zip: facility?.zip || '',
                        applyClientAddress:false,


                    }
                    return payload;
                }

                return {
                    name: '',
                    description: '',
                    ein: '',
                    tin: '',
                    address:'',
                    phone: '',
                    active: true,
                    enableForPricer: false,
                    facilityNPI:'',
                    billingProviderNpiRequest: mapBillingProviderNPIObject(null),
                    streetAddress: '',
                    state: null,
                    city:  null,
                    zip: '',
                    applyClientAddress:false,
                }
            }
        )

        return (state, props) => ({
            //create facility
            facilityCreatePending: state.facilities.create.pending,

            // update facility
            facilityUpdatePending: state.facilities.update.pending,
            currentClient:state.dashboards.selectedClient,
            preferredDashboardClient:state?.session?.user?.preferredDashboardClientId,


            // edit
            initialValues: selectInitialValues(state, props),
            mode: selectMode(state, props),
            STATES:STATES,
            getFormattedState:getInitialFormattedState

        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            facilityCreate: create,
            facilityUpdate: update,
            facilityGet: get,
        }, dispatch)
    })
)(injectIntl(FacilityDialogComponent));